// JS调用方法 以及操作说明
// function doAction(jsRequest)
// {
// var jsRequest = {"ActionName":"scanQRCode", "Callback":"Callback", "Params":"{}"}
// JsAction.doAction(jsRequest)
// }
// -1、安卓系统返回按钮点击，在Js实现全局Js方法：keyBack，处理返回上一个页面，在无法返回时执行09方法退出应该
// 00、推送ID： {"ActionName":"getJPushRegId", "Callback":"Js回调方法名称", "Params":"{}"}
// 01、获取定位：{"ActionName":"getLocation", "Callback":"Js回调方法名称", "Params":"{}"}
// 02、打开地图：{"ActionName":"openMap", "Callback":"", "Params":"{'longitude':'经度', 'latitude':'纬度', 'title':'标题'}"}
// 03、打开连接：{"ActionName":"openLink", "Callback":"", "Params":"{'url':'将要打开的连接'}"}
// 04、微信分享：{"ActionName":"wechatShare", "Callback":"", "Params":"{'title':'标题', 'desc':'描述', 'url':'连接', 'type':'SESSION-聊天/MOMENTS-朋友圈'}"}
// 05、QQ分享： {"ActionName":"qqShare", "Callback":"", "Params":"{{'title':'标题', 'desc':'描述', 'url':'连接', 'type':'SESSION-聊天/MOMENTS-QQ空间'}"}
// 06、保存屏幕：{"ActionName":"saveScreen", "Callback":"", "Params":"{}"}
// 07、扫描二维码：{"ActionName":"scanQRCode", "Callback":"", "Params":"{}"}
// 08、下载文件：{"ActionName"："downloadFile"， "Callback":"", "Params":"{'url':'文件路径', 'name':'保存文件名'}"}
// 09、退出应用：{"ActionName":"exitApp", "Callback":"", "Params":"{}"}
// 10、集合支付：{"ActionName"："pingPay"， "Callback":"回调方法的参数返回支付结果", "Params":"请求聚合支付服务器返回的Json"}
// 12、微信支付：{"ActionName":"wechatPay", "Callback":"回调方法的参数返回支付结果", "Params":"请求微信支付服务器返回的Json"}
// 微信支付处理返回值
//
// 13、支付宝支付：{"ActionName":"aliPay", "Callback":"回调方法的参数返回支付结果", "Params":"请求支付宝支付服务器返回的Json"}
// 支付宝支付处理返回值

// 14、微信登录：{"ActionName":"wechatLogin", "Callback":"回调方法的参数返回微信UnionId", "Params":"{}"}
//

const JsAction = {
  // 触发原生方法 JsonAction为Json对象
  doAction: function (JsonAction) {
    if (JsAction.isIphone()) {
    // ForiOS
      window.webkit.messageHandlers.doAction.postMessage(JSON.stringify(JsonAction))
    } else {
      //  For Android
      // window.prompt(JSON.stringify(JsonAction))
      window.Native.call(JSON.stringify(JsonAction))
    }
  },
  // 判断是否为iOS设备
  isIphone: function () {
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      return true
    }
    return false
  },
  // 打开本地的APP
  // schemaUrl     在APP内已经定义(蝌蚪商城为:fanc://kckd)
  // androidUrl    没安装时安卓的下载路径,
  // iosUrl        没安装时App Store的路径
  openApp: function (schemaUrl, androidUrl, iosUrl) {
    var nowTime = new Date().valueOf()
    setTimeout(function () {
      var launchTime = new Date().valueOf() - nowTime
      if (launchTime < 28) {
        if (JsAction.isIphone()) {
          window.location = iosUrl
        } else {
          window.location = androidUrl
        }
      }
    }, 25)
    window.location = schemaUrl
  },
  version: function () {
    document.write('1.0.0')
  }
}

export default JsAction



// WEBPACK FOOTER //
// ./src/js/JsAction.js